var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emd-panel__section" }, [
    _c("div", { staticClass: "emd-panel__block" }, [
      _c("div", { staticClass: "el-chunk" }, [
        _c("h2", { staticClass: "emd-text _color_default _type_caption" }, [
          _vm._v(" " + _vm._s(_vm.$t(_vm.acquirer.payment_method)) + " "),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "emd-panel__block" },
      [
        _c("JadeBox", [
          _c(
            "div",
            {
              staticClass:
                "eu-display_flex eu-row eu-align-items_center eu-justify_space-between",
            },
            [
              _c("jade-list-item", {
                staticClass: "h-20",
                attrs: {
                  label: _vm.$t("description.create", {
                    acquirer: this.$t(this.acquirer.payment_method),
                  }),
                },
                scopedSlots: _vm._u([
                  {
                    key: "leading",
                    fn: function () {
                      return [
                        _c(_vm.acquirerImageComponent, { tag: "component" }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "trailing",
                    fn: function () {
                      return [
                        _vm.canCreate
                          ? _c(
                              "jade-button",
                              {
                                attrs: {
                                  size: "medium",
                                  variant: "primary-solid",
                                  loading: _vm.loading,
                                },
                                on: {
                                  click: () =>
                                    _vm.$emit("handleCreate", _vm.acquirer),
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("register")) + " ")]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }